import { useInfiniteQuery } from "@tanstack/react-query";
import { QUERY_KEYS } from "app/data/common/queryKeys";
import AddressmanagerService from "app/data/address-manager/addressService";

export const useAssociatedAccounts = (selectedAddressId: string, search: string) => {
    const {
        data,
        fetchNextPage,
        hasNextPage,
        isLoading,
        refetch,
        isRefetching
    } = useInfiniteQuery({
        queryKey: [QUERY_KEYS.ASSOCIATED_ACCOUNTS, search, selectedAddressId],
        queryFn: async ({ pageParam = 0 }) => {
            return await AddressmanagerService.getInstance().getAssociatedAccounts(
                selectedAddressId,
                search,
                pageParam
            );
        },
        getNextPageParam: (lastPage) => {
            if (lastPage.last) return undefined;
            return lastPage.pageable.pageNumber + 1;
        },
        keepPreviousData: false,
        refetchOnWindowFocus: false,
        retry: false,
        enabled: !!selectedAddressId
    });

    return {
        data,
        fetchNextPage,
        hasNextPage,
        isLoading,
        refetch,
        isRefetching
    };
}